import { IntegrationModalView } from 'modules/mobileApps/types';
import { AuthDetails } from './formParts/AuthDetails';
import { AuthSelect } from './formParts/AuthSelect';

export const APNS_INTEGRATION_FORM_ID = 'apns-integration-form';

type Props = {
  handleContinue: () => void;
  modalView: IntegrationModalView;
};

export const ApnsIntegrationForm = ({ handleContinue, modalView }: Props) => {
  return modalView === IntegrationModalView.AUTH_SELECT ? (
    <AuthSelect handleContinue={handleContinue} />
  ) : (
    <AuthDetails />
  );
};
